import { apiCall } from '../utils/api'

export type Note = {
   id: string
   content: string
   authorName: string
   authorEmail: string
   createdAt: string
}

export type GetNotesRequest = {
   memberId: string
}

export type CreateNoteRequest = {
   memberId: string
   content: string
}

export async function getNotes(request: GetNotesRequest): Promise<Note[]> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/${request.memberId}/notes`,
      method: 'GET',
   })
   return result.data
}

export async function getLatestNote(request: GetNotesRequest): Promise<Note | null> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/${request.memberId}/notes/latest`,
      method: 'GET',
   })
   return result.data
}

export async function createNote(request: CreateNoteRequest): Promise<Note> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/${request.memberId}/notes`,
      method: 'POST',
      data: { content: request.content },
   })
   return result.data
}
